import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why people use IDE's (and how badly Win7 sucks)",
  "description": "",
  "published": "2009-10-25T00:00:00.000Z",
  "redirect_from": ["/blog/why-people-use-ides-and-how-badly-win7-sucks/swizec/785"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Just a quick thought on an early morning ...`}</p>
    <p>{`After having battled with the quintessential question of modern programming for several years I have finally figured out why people use IDE's and why many of them are so adamant about having this and that gizmo and this and that helping view and whatnot cluttering their work environment.`}</p>
    <p>{`It's all because they're `}<strong parentName="p">{`still`}</strong>{` using an OS `}{`*`}{`cough`}{`*`}{`windows`}{`*`}{`cough`}{`*`}{` that doesn't support `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Virtual_desktop",
        "title": "Virtual desktop"
      }}>{`virtual desktops`}</a>{`. What. The. Fuck. Why would anyone DO that? O.o ... makes no sense whatsoever`}</p>
    <p>{`What's perhaps even funnier is that even Windows 7 doesn't support virtual desktops. This, in my humblest of opinions, makes it antiquated by roughly 10 years at its release. Sad.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/d8f787f4-4619-47d5-84f7-b28903f389a6/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=d8f787f4-4619-47d5-84f7-b28903f389a6",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      